module.exports = __webpack_public_path__ + "img/ok.1fd5b745.svg";